import React, { useState, ChangeEvent } from 'react';

import './Home.css';

import Logo from './../../assets/logo_login2.png'

export function Home() {
    const [formData, setFormData] = useState({
        login: '',
        senha: ''
      })
    
      function cpfMask(value: any){
        return value
          .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
          .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d{1,2})/, '$1-$2')
          .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
      }
    
      function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
        setFormData({ ...formData, [event.target.name]: cpfMask(event.target.value)})
      }
    
    return (
        <div className="container">
          <div className="login">
            <img src={Logo} alt="Title GePrev" className='title' />
    
    
            <form action="" autoComplete='off'>
              <div className="field">
                <input 
                  type="text" 
                  placeholder="CPF" 
                  name="login" 
                  id="login" 
                  maxLength={14}
                  value={formData.login}
                  onChange={handleInputChange} 
                  />
              </div>
    
              <div className="field">
                <input 
                  type="password" 
                  placeholder="Senha" 
                  id="senha"
                  name="senha"
                  />
              </div>
              <div className="buttons">
                <button id='btn-entrar' onClick={() => {}}>Entrar</button>            
                <button type="button" id='portal' onClick={() => window.open('/portal', '_blank')}>Autoatendimento</button>
              </div>
            </form>    
    
          </div>
        </div>
      );
}